import { ActionType, useActionState } from "../../../status/state/actions.state";

import Button from '@ingka/button';
import { Item } from "../../types/item.types";
import React from 'react';
import { StyledTooltip } from "../../../../shared/styles/components/integrations.styles";
import pencilIcon from '@ingka/ssr-icon/paths/pencil';
import plusIcon from '@ingka/ssr-icon/paths/plus';
import styled from '@emotion/styled';
import { tokens } from '../../../../shared/styles/core/tokens';

interface AddButtonProps {
   parentItem: Item;
}

export const AddButton = ({ parentItem }: AddButtonProps) => {
   const onClick = () => useActionState.setState({ actionType: ActionType.adding, parentItem: parentItem });
   const onItemClick = () => useActionState.setState({ actionType: ActionType.editingItem, parentItem: parentItem });
   const dwpActCpInfoMissing = !parentItem.dwpActCpInfo || !parentItem.dwpActCpInfo.suppliers || parentItem.dwpActCpInfo.suppliers.length === 0;
   const isEditable = (parentItem?.dwpActCpInfo?.suppliers && parentItem.dwpActCpInfo.suppliers.length > 1) || (parentItem?.isDwpDeviationWarningHidable && !parentItem.isDwpDeviationWithinTolerance)

   return (
      <>
         {isEditable && (
            <StyledTooltip title={!dwpActCpInfoMissing ? 'DWP supplier weights' : ''}>
               <Button
                  type={'primary'}
                  onClick={(event) => {
                     onItemClick();
                     event.stopPropagation();
                  }}
                  disabled={dwpActCpInfoMissing}
                  ssrIcon={pencilIcon}
                  text="Filter"
                  iconOnly={true}
                  small={true}
               />
            </StyledTooltip>
         )}
         <TooltipWithSpacing title={'Add to item'}>
            <Button
               type={'primary'}
               onClick={(event) => {
                  onClick();
                  event.stopPropagation();
               }}
               ssrIcon={plusIcon}
               text="Filter"
               iconOnly={true}
               small={true}
            />
         </TooltipWithSpacing>
      </>
   );
};

const TooltipWithSpacing = styled(StyledTooltip)`
   padding-left: ${tokens.space.md};
`;
